<template>
  <div
    class="input-field"
    :class="{ 'error': validationError }"
  >
    <label v-if="label">
      {{ label }}
    </label>

    <div class="flex items-center border border-[#ddd] rounded">
      <span
        v-if="symbol"
        class="flex items-center justify-center h-9 w-11 bg-[#eee] font-medium border-r border-r-[#ddd] rounded-l"
      >
        {{ symbol }}
      </span>

      <IMaskComponent
        v-model:typed="model"
        :mask="Number"
        :min="0"
        input-mode="decimal"
        thousands-separator=","
        radix="."
        :map-to-radix="['.']"
        :scale="2"
        :normalize-zeros="true"
        :pad-fractional-zeros="true"
        class="!border-none w-full h-9 px-3 rounded"
      />
    </div>

    <small v-if="hint">{{ hint }}</small>

    <span
      v-if="validationError"
      class="validation-error-message"
    >
      {{ validationError }}
    </span>
  </div>
</template>

<script setup lang="ts">
import { IMaskComponent } from 'vue-imask';

defineProps({
  symbol: {
    type: String,
    default: 'R',
  },
  placeholder: {
    type: String,
    default: null,
  },
  label: {
    type: String,
    default: null,
  },
  required: {
    type: Boolean,
    default: false,
  },
  focus: {
    type: Boolean,
    default: false,
  },
  validationError: {
    type: Object,
    default: () => null,
  },
  hint: {
    type: String,
    default: '',
  },
});

const model = defineModel();
</script>
